module.exports = __webpack_public_path__ + "img/dewarp-after.61ccd10f.webp";